// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1z4Gq","question":"Question_question__NscKs","description":"Question_description__6G96_"};